 <template>
	<div class="window">
        <div class="header"><span v-html="translation[categoryName]"></span>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <ProgressBar :value="localOffset*5" />

            <h2>{{ question }}</h2>
            <h3 v-html="user1"></h3>

            <div class="answer-buttons">
                <button class="answer-button" 
                        :class="user1Answer==1?'active':''" 
                        v-html="answer1" 
                        @click="markAnswer(1,1)"
                    ></button>
                <button class="answer-button" 
                        :class="user1Answer==2?'active':''" 
                        v-html="answer2"
                        @click="markAnswer(1,2)"
                    ></button>
            </div>
        
            <h3 v-html="user2"></h3>

            <div class="answer-buttons">
                <button class="answer-button"
                        :class="user2Answer==1?'active':''" 
                        v-html="answer1"
                        @click="markAnswer(2,1)"
                    ></button>
                <button class="answer-button" 
                        :class="user2Answer==2?'active':''" 
                        v-html="answer2"
                        @click="markAnswer(2,2)"
                    ></button>
            </div>

        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon } from '@heroicons/vue/24/solid';
import axios from 'axios'
import ProgressBar from './Progressbar.vue';

export default {
    name: 'WpiszKod',
    props: {
        language: String,
        category: String,
        subcategory: String,
        offset: String,
        gameKey: String,
        plansza: String,
    },
    components: { 
        Cog6ToothIcon,
        ProgressBar

    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            code: '',
            timer: false,
            errorMessage: '',
            categoryName: this.gameKey,
            theme: localStorage.getItem('theme'),
            localCategory: this.category,
            localOffset: this.offset,
            localGameKey: this.gameKey,

            question:'',
            user1:'',
            user2:'',
            user1Answer:'',
            user2Answer:'',
            answer1:'',
            answer2:''
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
        let data = JSON.parse(localStorage.getItem('levels-'+this.localGameKey));
        this.categoryName = data.name;
        this.getQuestion()
    },
    methods: {
        markAnswer(user, answer) {
            if (user==1)
                this.user1Answer = answer;
            if (user==2)
                this.user2Answer = answer;
        },
        openSettings() {
            this.$emit('open-settings');
        },
        async getQuestion() {
            try {
                this.$emit('show-spinner', true);
                this.user1Answer = '';
                this.user2Answer = '';
                var data = new FormData();
                data.append('method', 'get-question');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('lang', this.lang);
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('offset', localStorage.getItem('game-offset'));

                await axios.post('https://gra.wrealizacji.pl/api3.php', data)
                .then((res) => {
                    if (res.data.type != 'error') {
                        this.question = res.data.l.name;
                        this.user1 = res.data.l.user1;
                        this.user2 = res.data.l.user2;
                        this.answer1 = res.data.l.answer1;
                        this.answer2 = res.data.l.answer2;

                        /*
                        dodac progresbar
                        */
                        this.$emit('show-spinner', false);
                    } else {
                        this.errorMessage = '';
                        console.log('error1')

                    }
                }).catch((error) => {
                    console.log(error);
                    this.errorMessage = this.translation.blad_polaczenia;
                    this.spinner = false;
                });
            } catch (err) {
                console.log('error2')
            }
        },
        async sendAnswers() {
            /*
            wysylam informacje
            */
            try {
                this.$emit('show-spinner', true);
                var data = new FormData();
                data.append('method', 'save-question');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('lang', this.lang);
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('offset', localStorage.getItem('game-offset'));
                data.append('me', this.user1Answer);
                data.append('opponent', this.user2Answer);

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    if (res.data.type == 'error') {
                        this.$emit('on-change-bottom-message', res.data.message);
                        this.$emit('show-spinner', true);
                    } else {
                        this.checkNextQuestion();
                    }
                }).catch((error) => {
                    console.log(error);
                    this.errorMessage = this.translation.blad_polaczenia;
                    this.$emit('show-spinner', false);
                    this.$emit('on-change-bottom-message', this.translation.blad_polaczenia);
                });
            } catch (err) {
                console.log('error2a')
                this.$emit('show-spinner', false);
                this.$emit('on-change-bottom-message', this.translation.blad_polaczenia);
            }
        },
        async checkNextQuestion() {
            /*
            sprawdzenie czy uzytkownik juz odpowiedzial i jak tak to lecimy dalej
            */

            try {
                var data = new FormData();
                data.append('method', 'check-question');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('offset', localStorage.getItem('game-offset'));

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    if (res.data.type == 'success') {
                        /*
                        przesunac offset
                        */
                        this.$emit('on-change-bottom-message', '');
                        let offset = localStorage.getItem('game-offset');
                        offset++
                        this.localOffset=offset;
                        localStorage.setItem('game-offset', offset);
                        if (offset<20) {
                            this.getQuestion(); 
                        } else {
                            this.$emit('on-finished');
                        }
                    } else {
                        this.$emit('on-change-bottom-message', this.translation.oczekuje_na_druga_osobe);
                        setTimeout(function() {
                            this.checkNextQuestion();
                        }.bind(this), 500);
                    }
                }).catch((error) => {
                    console.log(error)
                    setTimeout(function() {
                        this.checkNextQuestion();
                    }.bind(this), 500);
                });
            } catch (err) {
                setTimeout(function() {
                    this.checkNextQuestion();
                }.bind(this), 500);
            }          
        },
        async checkOpponent() {
            /*
            sprawdzenie czy uzytkownik juz odpowiedzial i pokazac info o tym
            */
            try {
                var data = new FormData();
                data.append('method', 'check-answered');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('offset', localStorage.getItem('game-offset'));

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    if (res.data.type == 'success') {
                        /*
                        przesunac offset
                        */
                        this.$emit('on-change-bottom-message', this.translation.druga_osoba_odpowiedziala);
                        setTimeout(function() {
                            this.checkOpponent();
                        }.bind(this), 1000);
                    } else if (res.data.type == 'error') {
                        this.$emit('go-to-poziomy');
                    } else {
                        setTimeout(function() {
                            this.checkOpponent();
                        }.bind(this), 1000);
                    }
                }).catch((error) => {
                    console.log(error)
                    setTimeout(function() {
                        this.checkOpponent();
                    }.bind(this), 1000);
                });
            } catch (err) {
                setTimeout(function() {
                    this.checkOpponent();
                }.bind(this), 1000);
            }          
        }
    },
    watch: {
        user1Answer() {
            if (this.user1Answer != '' && this.user2Answer != '') {
                console.log('wysylam');
                this.$emit('show-spinner', true);
                //this.$emit('on-change-bottom-message', 'Czekam na odpowiedź drugiego gracza');
                this.sendAnswers();
            }
        },
        user2Answer() {
            if (this.user1Answer != '' && this.user2Answer != '') {
                console.log('wysylam');
                this.$emit('show-spinner', true);
                //this.$emit('on-change-bottom-message', 'Czekam na odpowiedź drugiego gracza');
                this.sendAnswers();
            }
        },
        localGameKey(cat) {
            let data = JSON.parse(localStorage.getItem('levels-'+cat));
            this.categoryName = data.name;
        },
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
            this.getQuestion()
        }
    },
    mounted() {
        /*
        uruchomic zegar sprawzdajacy czy uzytkownik juz odpowiedzial
        */
       setTimeout(function() {
            this.checkOpponent()
       }.bind(this), 2000);
    }
}
</script>

<style scoped>
.answer-buttons {
    display: flex;
    align-items: stretch;
    gap: 10px;
    margin: 20px 0;
}

.answer-buttons button {
    /*
    background-color: #007bff;
    color: white;
    padding: 15px 25px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    min-height: 50px;
    align-items: center;
    */

    display: flex;
    justify-content: center;
    flex: 1;

    font-size: 1em;
    /*height: 3em;
    width: 80%;*/
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
    font-size: 1em;
    font-family: 'Jost', sans-serif;
    background-color: transparent;
    color: var(--bs-button-text);
    position: relative;
    border-color:white;
    border: 1px solid var(--bs-gradient-to);
    padding:16px 10px;
}
.answer-buttons button.active {
    background-color: var(--bs-gradient-to);
}

.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}



.mt2x {
    margin-top: 2em;
}

</style>
